<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="integral_center">
      <div class="top_box flex Flexjustify Flexalign mt-20">
        <div class="top_box_content flex FlexBetween">
          <div class="top_left_box">
            <div class="flex Flexalign my_integral_box">
              <el-image class="headImage" :src="userInfo.headImage"></el-image>
              <div class="user_name mx-10 toverflow">{{ userInfo.name }}</div>
              <el-image class="member_level_gold_icon" :src="userInfo.memberLevelIcon"></el-image>
            </div>
            <div class="progress_box">
              <div>成长值{{ signInfo.userGrowth || 0 }}，还差{{ signInfo.nextLevelGrowth || 0 }}升级</div>
              <el-progress class="mt-15" :text-inside="true" :stroke-width="8"
                :percentage="calculateProgress(signInfo.userGrowth, signInfo.nextLevelGrowth)" status="success"
                :show-text="false" color="#00D498" />
            </div>
            <div class="my-15 ml-20">积分统计</div>
            <div class="copper_coin_detail ml-15 p-30 flex Flexalign FlexBetween">
              <div class="flex Flexalign copper_coin_left">
                <el-image class="small_copper_coin_icon" :src="iconPath('small_copper_coin_icon.png')"></el-image>
                <div class="ml-10">铜积分</div>
              </div>
              <div class="intergal_value">{{ signInfo.userCopperPoints }}</div>
              <el-image class="user_integral_bg2" :src="iconPath('user_integral_bg2.png')"></el-image>
            </div>
          </div>
          <div class="top_right_box p-20">
            <div class="right_top_content flex Flexalign FlexBetween">
              <div class="flex Flexalign">
                <div class="cursor_pointer">已连续签到 <span class="sign_days">{{ signInfo.continueDays }}</span> 天 > </div>
                <div class="sign_rewardInfo ml-10">{{ signInfo.futureRewardInfo }}</div>
              </div>
              <div class="flex Flexalign rule_detail cursor_pointer" @click="showSignInRule">
                规则
                <el-image class="rule_detail_icon" :src="iconPath('rule_icon_black.png')"></el-image>
              </div>
            </div>
            <div class="sign_list scroll_x hidden_scroll flex Flexalign FlexBetween">
              <div class="sign_one mt-30 mr-10" v-for="(item, index) in signList" :key="index">
                <div class="sign_one_normal flex flexcolumn Flexjustify Flexalign"
                  :class="[getIsTodaySignIn(item.day) ? 'sign_reward_today' : '']">
                  <el-image class="sign_in_day_top_bg" :src="iconPath('sign_in_day_top_bg.png')"
                    v-if="getIsTodaySignIn(item.day)"></el-image>
                  <div class="sign_in_day_top_bg" v-if="getIsTodaySignIn(item.day)">今日可领</div>
                  <div>{{ `第${index + 1}天` }}</div>
                  <el-image class="gold_coin_icon" :src="iconPath('gold_coin_icon.png')"
                    v-if="item.recordState != 1"></el-image>
                  <el-image class="gold_coin_icon" :src="iconPath('sign_in_success_icon.png')"
                    v-if="item.recordState == 1"></el-image>
                  <div class="sign_finish" v-if="item.recordState == 1">已签到</div>
                  <!-- 有补签次数 -->
                  <div class="sign_repair flex Flexalign FlexBetween cursor_pointer"
                    v-if="item.recordState == 2 && signInfo.suppCount" @click="retroactiveSignIn(item)">
                    <el-image class="signature_icon" :src="iconPath('signature_icon.png')"
                      v-if="item.recordState == 2"></el-image>
                    <div>可补签</div>
                  </div>
                  <!-- 无补签次数 -->
                  <div class="sign_repair flex Flexalign Flexjustify"
                    v-if="item.recordState == 2 && !signInfo.suppCount">
                    <div>已过期</div>
                  </div>
                  <div class="sign_finish sign_reward_box" v-if="item.recordState == 0">已签到</div>
                  <div class="sign_reward flex Flexalign" v-if="item.recordState == 0"
                    :class="[getIsTodaySignIn(item.day) ? '' : 'sign_reward_wait']">
                    <div>{{ item.copperPoints || 0 }}铜币</div>
                    <!-- <div class="ml-10">{{ item.honorValue || 0 }}EX</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="btn_sign cursor_pointer" @click="signIn(0)" :class="[btnText == '已签到' ? 'btn_signed' : '']">{{
              btnText
              }}</div>
          </div>
        </div>
      </div>
      <div class="task_box flex Flexjustify Flexalign my-20">
        <div class="task_content flex FlexBetween">
          <div class="task_left">
            <div class="task_newbie">新手任务</div>
            <div class="task_attention">完成新手任务，领取奖励</div>
            <div class="newbie_task_list">
              <div class="newbie_task_one flex Flexalign FlexBetween" v-for="(item, index) in newbieTaskList"
                :key="index">
                <div class="task_one_left flex Flexalign">
                  <el-image class="first_weixin_icon" :src="item.taskIcon"></el-image>
                  <div class="task_info flex flexcolumn FlexBetween mar_left_15 flex-1 scroll_x">
                    <div class="flex Flexalign">
                      <div class="task_title_text">{{ item.taskName }}</div>
                    </div>
                    <div class="task_attention_text flex Flexalign">
                      {{ item.taskRequirement }}
                      <el-image class="task_integral_icon mar_left_20"
                        :src="iconPath('small_copper_coin_icon.png')"></el-image>
                      <div class="task_award mar_left_5">
                        +{{ item.copperPoints }}铜币
                      </div>
                      <!-- <el-image class="task_integral_icon mar_left_20"
                        :src="iconPath('small_experience_icon.png')"></el-image>
                      <div class="task_award mar_left_5">
                        +{{ item.honorValue }}荣誉值
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="btn_complete cursor_pointer" :class="[item.completeState == 0 ? 'btn_active' : '']">
                  {{ item.completeState == 1 ? "已完成" : "去完成" }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex flexcolumn FlexBetween">
            <div class="task_left">
              <div class="task_newbie">日常任务</div>
              <div class="task_attention">
                日事日清，聚力攻坚
              </div>
              <div class="newbie_task_list">
                <div class="newbie_task_one flex Flexalign FlexBetween" v-for="(item, index) in studyTaskList"
                  :key="index">
                  <div class="task_one_left flex Flexalign">
                    <el-image class="first_weixin_icon" :src="item.taskIcon"></el-image>
                    <div class="task_info flex flexcolumn FlexBetween mar_left_15 flex-1 scroll_x">
                      <div class="flex Flexalign">
                        <div class="task_title_text">{{ item.taskName }}</div>
                      </div>
                      <div class="task_attention_text flex Flexalign">
                        {{ item.taskRequirement }}
                        <el-image class="task_integral_icon mar_left_20"
                          :src="iconPath('small_copper_coin_icon.png')"></el-image>
                        <div class="task_award mar_left_5">
                          +{{ item.copperPoints }}铜币
                        </div>
                        <!-- <el-image class="task_integral_icon mar_left_20"
                          :src="iconPath('small_experience_icon.png')"></el-image>
                        <div class="task_award mar_left_5">
                          +{{ item.honorValue }}荣誉值
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="btn_complete cursor_pointer" :class="[item.completeState == 0 ? 'btn_active' : '']">
                    {{ item.completeState == 1 ? "已完成" : "去完成" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <signInSuccess ref="signInSuccess"></signInSuccess>
    <signInRule ref="signInRule"></signInRule>
    <confirm ref="confirm" :confirmText="confirmText" @signIn="signIn"></confirm>
  </moe-page>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "@/assets/utils/dbucTrtl";
import signInSuccess from "@/components/popup/signInSuccess.vue";
import signInRule from "@/components/popup/signInRule.vue";
import confirm from "@/components/popup/confirm.vue";
export default {
  name: "GjkcH5Index",
  components: {
    signInSuccess, signInRule, confirm
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      integralInfo: {
        integralNum: 145,
        integralOvered: 2,
        overTime: "2025.02.19",
        checkInDay: 145,
      },
      newbieTaskList: [
        // {
        //   icon: "beginners_mission_icon1.png",
        //   title: "完成个人信息填写",
        //   attention: "首次完成个人信息内容全部填写",
        //   status: 0,
        //   award: 10,
        // },
        // {
        //   icon: "beginners_mission_icon2.png",
        //   title: "首次发布评价",
        //   attention: "首次完成个人信息内容全部填写备份",
        //   status: 1,
        //   award: 10,
        // },
        // {
        //   icon: "beginners_mission_icon3.png",
        //   title: "首次参与课程学习",
        //   attention: "首次绑定微信账号，换绑不计算",
        //   status: 0,
        //   award: 10,
        // },
        // {
        //   icon: "beginners_mission_icon4.png",
        //   title: "收藏3门课程",
        //   attention: "首次收藏3门课程",
        //   status: 1,
        //   award: 10,
        // },
        // {
        //   icon: "beginners_mission_icon5.png",
        //   title: "关注机构账号",
        //   attention: "首次关注3个机构账号",
        //   status: 0,
        //   award: 10,
        // }
      ],
      studyTaskList: [
        // {
        //   icon: "daily_task_icon1.png",
        //   title: "记录学习笔记",
        //   attention: "记录3篇学习笔记",
        //   status: 0,
        //   award: 10,
        // },
        // {
        //   icon: "daily_task_icon2.png",
        //   title: "累计看视频",
        //   attention: "观看视频累计30min",
        //   status: 1,
        //   award: 10,
        // },
      ],

      signInfo: {},
      signInParams: {
        signinId: 2,
        userId: '',
        memberLevelId: '',
        signinDayOfWeek: 7
      },
      // 点击的补签day
      retroactiveSignInDay: '',
      btnText: '立即签到',
      confirmText: "",
      signList: [],
    };
  },

  mounted() {
    this.getSignInList();
    this.getBignnerTask();
    this.getDailyTask();
  },

  methods: {
    // 新手任务列表
    getBignnerTask() {
      this.$Api.user.getBignnerTask({ userId: this.userInfo.buyerUserId }).then(res => {
        this.newbieTaskList = res.data.data;
      }).catch(() => { })
    },
    // 新手任务列表
    getDailyTask() {
      this.$Api.user.getDailyTask({ userId: this.userInfo.buyerUserId }).then(res => {
        this.studyTaskList = res.data.data;
      }).catch(() => { })
    },
    // 计算等级百分比
    calculateProgress(current, next) {
      if (!current) {
        current = 0;
      }
      if (!next) {
        next = 0;
      }
      let percentage = current / (current + next);
      if (isNaN(percentage)) return 0
      return percentage * 100;
    },
    showSignInRule() {
      this.$refs.signInRule.signInRuleShow = true;
      this.$refs.signInRule.signInRuleContent = this.signInfo.rewardDescription;
    },
    getSignInList() {
      this.signInParams.memberLevelId = this.userInfo.memberLevelId;
      this.signInParams.userId = this.userInfo.buyerUserId;
      let today = new Date().getDay() + 1;
      this.signInParams.signinDayOfWeek = today;
      this.$Api.user.getSignInList(this.signInParams).then(res => {
        this.signInfo = res.data.data;
        let todayStatus = this.signInfo.daysList.filter(item => item.day == today)[0];
        if (todayStatus?.recordState == 1) {
          this.btnText = '已签到'
        } else {
          this.btnText = '立即签到'
        }
        this.signList = res.data.data.daysList;
        this.confirmText = `本周剩余可补签次数为 ${res.data.data.suppCount} 是否补签`
      }).catch(() => { })
    },
    // 提前创建防抖函数实例
    debouncedSignIn: debounce(function (type) { // ✅ 注意用 function 保留 this 指向
      const params = {
        userId: this.userInfo.buyerUserId,
        signinDayOfWeek: new Date().getDay() + 1,
        signinType: type,
        copperPoints: this.signInfo.copperPoints,
        honorValue: this.signInfo.honorValue,
        continueRewardDays: this.signInfo.continueRewardDays
      };
      // type 为1的情况是补签
      if (type == 1) {
        let retroactiveSignIn = this.signList.filter(item => item.day == this.retroactiveSignInDay)[0];
        if (this.$Tools.empty(retroactiveSignIn)) {
          this.$Dialog.toast('补签失败', { type: 'warning' });
          this.$refs.confirm.confirmShow = false;
          return
        }
        params.copperPoints = retroactiveSignIn.copperPoints;
        params.honorValue = retroactiveSignIn.honorValue;
        params.signinDayOfWeek = retroactiveSignIn.day;
      }
      params.signinId = this.signInParams.signinId;
      this.$Api.user.signIn(params).then(() => {
        this.$refs.signInSuccess.signInSuccessShow = true;
        this.$refs.signInSuccess.signSuccessInfo.copperPoints = params.copperPoints;
        this.$refs.signInSuccess.signSuccessInfo.honorValue = params.honorValue;
        this.getSignInList();
        this.$refs.confirm.confirmShow = false; // 关闭补签弹窗
      }).catch(() => {
        this.$refs.confirm.confirmShow = false;
      })
      // 此处调用实际接口
    }, 500),

    // 事件触发方法
    signIn(type) {
      if (type == 0) {
        let today = new Date().getDay();
        if (this.signList[today]?.recordState == 1) {
          this.$Dialog.toast("今天已经签过到了");
          return
        }
      }
      this.debouncedSignIn(type); // ✅ 调用已防抖处理的函数
    },
    // 补签
    retroactiveSignIn(info) {
      this.$refs.confirm.confirmShow = true;
      this.retroactiveSignInDay = info.day;
    },
    // 判断是否是当天待签到
    getIsTodaySignIn(day) {
      let week = new Date().getDay();
      if ((week + 1) != day) {
        return false
      } else {
        return true
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.integral_center {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.top_box {
  width: 100%;
  height: 300px;
  box-sizing: border-box;

  .top_box_content {
    width: $pageMainWidth;
  }

  .top_left_box {
    background-size: 100% 100%;
    width: 460px;
    height: 300px;
    // background-color: linear-gradient(180deg, #FFF7E3 0%, #FFFEFD 22%, #FFFFFF 100%);
    border-radius: 10px;
    background-image: url('../../../public/static/icon/user_integral_bg.png'), linear-gradient(180deg, #FFF7E3 0%, #FFFEFD 22%, #FFFFFF 100%);

    .my_integral_box {
      padding: 10px 20px;
      padding-top: 30px;
      width: 100%;
      box-sizing: border-box;
      z-index: 9;

      .headImage {
        width: 54px;
        height: 54px;
        border-radius: 50%;
      }

      .user_name {
        font-size: 16px;
        color: #111111;
        max-width: 200px;
      }

      .member_level_gold_icon {
        // width: 58px;
        height: 32px;
      }

      .integral_cenetr {
        position: absolute;
        right: 20px;
      }
    }

    .progress_box {
      padding: 10px 20px;
      font-size: 12px;
      color: #909090;
      z-index: 9;

      :deep(.el-progress-bar__outer) {
        background-color: #f0eeee;
      }

      :deep(.el-progress-bar__inner) {
        background: linear-gradient(142deg, #FF6367 0%, #FFBA6F 100%);
      }
    }

    .copper_coin_detail {
      width: 430px;
      height: 75px;
      background: #F7F7F7;
      border-radius: 10px;
      box-sizing: border-box;
      position: relative;

      .copper_coin_left {
        font-size: 14px;
        color: #303030;

        .small_copper_coin_icon {
          width: 24px;
          height: 24px;
        }
      }

      .intergal_value {
        font-size: 26px;
        color: #303030;
      }

      .user_integral_bg2 {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 34px;
        height: 34px;
      }
    }
  }

  .top_right_box {
    width: 720px;
    height: 300px;
    background: linear-gradient(180deg, #FFF7E3 0%, #FFFEFD 22%, #FFFFFF 100%);
    border-radius: 10px;
    box-sizing: border-box;

    .right_top_content {
      .sign_days {
        color: #FF5001;
      }

      .sign_rewardInfo {
        font-size: 14px;
        color: #909090;
      }

      .rule_detail {
        font-size: 14px;
        // color: #ff4f00;
      }

      .rule_detail_icon {
        width: 16px;
        height: 16px;
        margin-left: 6px;
      }
    }

    .sign_list {
      padding: 0 10px 10px;

      .sign_one {
        .sign_one_normal {
          width: 113px;
          height: 112px;
          background: #FFFFFF;
          box-shadow: 0px 0 10px 0px rgba(0, 0, 0, 0.08);
          border-radius: 6px;
          position: relative;

          .gold_coin_icon {
            width: 50px;
            height: 50px;
          }

          .sign_finish {
            font-size: 12px;
            color: #ff4f00;
          }

          .sign_repair {
            font-size: 12px;
            color: #13d6aa;
            width: 60px;

            .signature_icon {
              width: 15px;
              height: 15px;
            }
          }

          .sign_reward {
            font-size: 12px;
            color: #ff4f00;
            position: absolute;
            bottom: 8px;
          }

          .sign_reward_wait {
            color: #606060;
          }

          .sign_reward_box {
            opacity: 0;
          }
        }

        .sign_reward_today {
          width: 164px;
          height: 112px;
          position: relative;

          .sign_in_day_top_bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 164px;
            height: 35px;
            text-align: center;
            line-height: 35px;
            color: #fff;
          }
        }

        .sign_one_final {
          width: 301px;
          height: 114px;
          background: #FFFFFF;
          box-shadow: 0px 0 10px 0px rgba(0, 0, 0, 0.08);
          border-radius: 6px;

          .final_reward {
            .sign_in_mysterious_icon {
              width: 86px;
              height: 86px;
            }

            .sign_reward_wait {
              font-size: 12px;
              color: #606060;
            }
          }
        }
      }
    }

    .btn_sign {
      width: 343px;
      height: 53px;
      background: #FF5001;
      border-radius: 12px;
      font-size: 18px;
      color: #ffffff;
      line-height: 53px;
      text-align: center;
      margin: 20px auto;
    }

    .btn_signed {
      background: #C2C4CC;
    }
  }
}

.task_title {
  width: $pageMainWidth;
  margin: 40px auto 20px;
  font-size: 24px;
  color: #333333;
  text-align: start;
}

.task_box {
  width: 100%;

  .task_content {
    width: $pageMainWidth;

    .task_left {
      width: 585px;
      height: 627px;
      background: #ffffff;
      border-radius: 10px;
      padding: 20px;
      box-sizing: border-box;

      .task_newbie {
        font-weight: bold;
        font-size: 18px;
        color: #111111;
        border-bottom: 1px solid rgba(36, 35, 36, 0.1);
        padding-bottom: 20px;
      }

      .task_attention {
        color: #999999;
        margin-top: 20px;
      }

      .newbie_task_list {
        .newbie_task_one {
          margin-top: 26px;

          .task_one_left {
            .first_weixin_icon {
              width: 40px;
              height: 40px;
            }

            .task_info {
              height: 50px;
              max-width: 390px;
              white-space: nowrap;

              .task_title_text {
                color: #333333;
                font-weight: 600;
              }

              .task_integral_icon {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
              }

              .task_award {
                font-weight: 500;
                font-size: 12px;
                color: #303030;
              }

              .task_attention_text {
                font-size: 14px;
                color: #999999;
              }
            }
          }

          .btn_complete {
            width: 72px;
            height: 36px;
            background: #C2C4CC;
            border-radius: 6px;
            line-height: 35px;
            text-align: center;
            font-size: 14px;
            color: #666666;
          }

          .btn_active {
            background: #FF5001;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }

    .task_right_top {
      height: 339px;
    }

    .task_right_bottom {
      height: 272px;
    }
  }
}
</style>